module.exports = __webpack_public_path__ + "media/images/topics/topics-grid-bg-ste-14b37ee31191388bdd571ad073db3c5f.png";